import { Box, CircularProgress } from '@mui/material';

const PageLoading = () => (
  <Box
    sx={{
      minHeight: 'calc(100vh - 192px)',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default PageLoading;
